"use strict";
/**
 * Type definitions for Parcel Rate Request.
 * Forked from batch.ts — corresponds to RateQuality's ParcelShipmentDataToRate.cs
 * (not the shared ShipmentDataToRate.cs used by Batch Rate/Rate Compare/AP Testing/GEO Mileage).
 */
Object.defineProperty(exports, "__esModule", { value: true });
